enum OperationState {
  PENDING,
  IN_PROGRESS,
  SUCCESS,
  FAILED,
}

export default OperationState;
